import React, { useEffect, useState } from 'react'
import FiltersAndSearchBarDashboard from '../components/dashboard/filtersandsearchbardashboard'
import FinanceDataCard from '../components/dashboard/financedatacard'
import { Button } from '@mui/material'
import ChartApi from './chart.api'
import * as XLSX from 'xlsx';
import BookingDataCard from '../components/dashboard/bookingdatacard'
import PendingActionsCard from '../components/dashboard/pendingActionsCard'
import PaymentDaysCard from '../components/dashboard/paymentdayscard'
import ProductWiseAnalysisCard from '../components/dashboard/productwiseanalysiscars'
import FinanceDetailsCard from '../components/dashboard/financedetailscard'
import { loginStore } from '../state/CommonState'
import Download_icon from '../assets/images/download_icon.png' 
import PendingPayTable from '../components/dashboard/PendingPayTable'

export function ChartRedesignHome() {

     const [entList,setEntList] = useState([])
      const [results, setResults] = useState({})
          const [entityFinance, setEntityFinance] = useState("ALL")
          const [chartSelectedEntities, setChartSelectedEntities] = useState([])
          const [openFinance, setOpenFinance] = useState(false)
          const [openPendingPay, setOpenPendingPay] = useState(false)
          const [PendingPayData, setpendingPayData] = useState({})
          const [ type , setType] = useState('TCU')
  
  
      useEffect(() => {
          ChartApi.getFinanceData(setResults, entityFinance)
      }, [entityFinance])
      useEffect(() => {
          setEntList(results?.entityList)
          let entityIds = []
          if (entityFinance === "ALL") {
              entityIds = results?.entityList?.filter(e => e.erpnumber && e.entityId)?.map(e => e.entityId) || []
              setChartSelectedEntities(entityIds)
          }
      }, [results])

  const DownloadFinanceSht = async (x) => {
      let data = results
      let data1 = data.totalList
      let data2 = data.pendinglist
      let data3 = data.acctountlist
      let data4 = data.upcomingList
      let data5 = data.overdueList

      const ws1 = XLSX.utils.json_to_sheet(data1);
      const ws2 = XLSX.utils.json_to_sheet(data2);
      const ws3 = XLSX.utils.json_to_sheet(data3);
      const ws4 = XLSX.utils.json_to_sheet(data4);
      const ws5 = XLSX.utils.json_to_sheet(data5);

      const wb = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(wb, ws1, 'Total Credit Utilized');
      XLSX.utils.book_append_sheet(wb, ws2, 'Pending Reconciliation');
      XLSX.utils.book_append_sheet(wb, ws3, 'Accounting Error');
      XLSX.utils.book_append_sheet(wb, ws4, 'Upcoming Dues');
      XLSX.utils.book_append_sheet(wb, ws5, 'Overdue Amount');
     
      if(x !== 'sendcusmail'){
        XLSX.writeFile(wb, 'FinanceStatement.xlsx');
      }
      if(x === 'sendcusmail'){
        const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([wbout], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const file = new File([blob], 'FinanceStatement.xlsx', {
          type: blob.type,
        });
        const formData = new FormData();
        formData.append("myFile", file );
        // let body = formData 
        ChartApi.sendCusFinSht(formData , (Data)=> {
          console.log('data' , Data);
          
        }) 
      }
  } 

  const SendFinanceShtMailToCus = () => {


  }

  return (
    <div style={{ padding : "2% 1%" , backgroundColor : "#e3e5e8"  }}>
    {
      openPendingPay ? 
       <><PendingPayTable PendingPayData ={PendingPayData} erpData={results.totalList} setOpenPendingPay={setOpenPendingPay}/></> 
       : null 
    }
    {   
      !openPendingPay && openFinance ? 
      <FinanceDetailsCard results ={results} setOpenFinance={setOpenFinance}  type={type}/> : !openPendingPay &&
      <div>
      <div className='is-flex is-justify-content-space-between mb-1'>
      <p
        className="figtree-text"
        style={{ fontSize : "28px"  }}>
        Welcome back , <span style={{ color : "#E87A1A"}}>{loginStore.userRec.firstName + ' ' + loginStore.userRec.lastName }!  </span>
      </p>
      <div>
      { entityFinance !== 'ALL' &&
                  <button className='figtree-text' style={{ padding: "4px  12px", borderRadius: "5px", backgroundColor: "#ECF4FF", border: "1px solid #5086D1", color: "#5086D1" , display: 'flex' , fontWeight : '600' , fontSize : '14px' ,  alignItems : 'center'}} onClick={() => DownloadFinanceSht()} >
                    <span  className='figtree-text' style={{ padding: '1% 1%', borderRadius: '5px' }}>
                      <img                        
                        src={Download_icon}
                        alt='vfnvf'
                        style={{ height:"18px" , width : '18px'}}
                      />
                    </span>
                    <span className='figtree-text' style={{ whiteSpace: "nowrap" , marginLeft: '3%' ,fontWeight : '600' }}>
                      Download Finance
                    </span>
                  </button>
      }
       {/* { entityFinance !== 'ALL' &&
        <button className='ml-2' style = {{ padding: "8px  15px" , borderRadius : "2px" , backgroundColor : "#D9DDFF" , border : "1px solid #2C358A" , color : "#2C358A"   }} onClick={()=>DownloadFinanceSht('sendcusmail')} >
        Download Mail
       </button> 
      
       } */}
       </div>
       </div>
      <FiltersAndSearchBarDashboard results ={results}  entList={entList}  entityFinance={entityFinance}  setChartSelectedEntities={setChartSelectedEntities} setEntityFinance={setEntityFinance} setEntList={setEntList} />
      <div className='is-flex wd_100' style={{ marginBottom : "1%"}}>
      <FinanceDataCard results ={results} setOpenFinance={setOpenFinance} setType={setType} />
      <BookingDataCard  chartSelectedEntity={chartSelectedEntities} setOpenPendingPay={setOpenPendingPay}  setpendingPayData= {setpendingPayData}/>
      </div>
      <PendingActionsCard  erpData={results.totalList} />    
        <div className='is-flex mt-2'>      
      <PaymentDaysCard entityFinance={entityFinance}/>
      <ProductWiseAnalysisCard/>
      </div>      
      </div>
    }      
    </div>
  )
}


